module.exports = __webpack_public_path__ + "img/ears-02.fb917388.svg";